import { TutorialStep } from "..";

export const ClsTrainWorkSteps: TutorialStep[] = [
  {
    target: "#select-ai-server",
    content: "학습 진행시킬 서버를 선택해줍니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#insp-img-table",
    disableOverlayClose: true,
  },
  {
    target: "#image-list-panel",
    content: "앞의 단계에서 넣었던 이미지 리스트를 확인할 수 있습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#auto-train-setting",
    content: "클릭하여 자동학습 설정을 확인합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#auto-train-panel",
    content: "프로젝트 생성시 설정했던 자동학습 옵션을 변경할 수 있습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#labeling-btn",
    content: `라벨링 버튼입니다. \n버튼에 써있는 숫자를 키보드에서 눌러서 라벨링을 쉽게 진행할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#labeling-btn",
    content: `키보드로 1 또는 2를 눌러서 이미지에 라벨링을 진행해보세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#image-list-panel",
    content: `OK(1) 10장 라벨링을 진행하세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#ai-progress",
    content: `학습/검증이 진행될때 진행률을 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#image-list-panel",
    content: `검증이 진행될때는 각 이미지의 AI label과 score값을 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
